(function(){
  function initChrome(root){
    if(!root || root.dataset.chromeReady === 'true') return;
    root.dataset.chromeReady = 'true';

    var header = root.querySelector('[data-intervine-header]');
    var panel = root.querySelector('[data-intervine-mobile-panel]');
    var openButton = root.querySelector('[data-intervine-open-menu]');
    var closeButton = root.querySelector('[data-intervine-close-menu]');

    function setHeaderState(){
      if(header) header.classList.toggle('scrolled', window.scrollY > 24);
    }

    function openMenu(){
      if(!panel) return;
      panel.classList.add('open');
      document.body.style.overflow = 'hidden';
    }

    function closeMenu(){
      if(!panel) return;
      panel.classList.remove('open');
      document.body.style.overflow = '';
    }

    setHeaderState();
    window.addEventListener('scroll', setHeaderState, { passive:true });

    if(openButton) openButton.addEventListener('click', openMenu);
    if(closeButton) closeButton.addEventListener('click', closeMenu);
    if(panel) panel.querySelectorAll('a').forEach(function(link){ link.addEventListener('click', closeMenu); });

    document.addEventListener('keydown', function(event){
      if(event.key === 'Escape') closeMenu();
    });
  }

  function initAll(){
    document.querySelectorAll('[data-intervine-brand-chrome]').forEach(initChrome);
  }

  if(document.readyState === 'loading'){
    document.addEventListener('DOMContentLoaded', initAll);
  }else{
    initAll();
  }
})();
